import instance from 'utils/apiCalls';
import { ADMIN_LEVEL_URLS } from './AdminLevelUrls';
import { AdminLevelFormI, paramsI } from '../../../types/interface';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'redux/rootReducer';
import { adminLevelSlice } from './AdminLevelSlice';

const { actions } = adminLevelSlice;
export const getAdminLevels =
  (params?: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(ADMIN_LEVEL_URLS.GET_ADMIN_LEVELS, {
      params
    });
    dispatch(
      actions.setAdminLevelTotalPages({
        totalPages: response?.data?.pagination?.totalPages,
        totalRecords: response?.data?.pagination?.totalRecords
      })
    );
    return response;
  };

export const getSingleAdminLevel =
  (id: number) => async () => {
    const response = await instance.get(
      ADMIN_LEVEL_URLS.GET_SINGLE_ADMIN_LEVEL.replace(':id', id?.toString())
    );
    return response;
  };

export const getAdminLevelMappings = (params?: paramsI) => async () => {
  const response = await instance.get(
    ADMIN_LEVEL_URLS.GET_ADMIN_LEVELS_MAPPINGS,
    { params }
  );
  return response;
};

export const createAdminLevel = (data: AdminLevelFormI) => async () => {
  const response = await instance.post(
    ADMIN_LEVEL_URLS.CREATE_ADMIN_LEVEL,
    data
  );
  return response;
};

export const updateAdminLevel =
  (id: number, data: AdminLevelFormI) => async () => {
    const response = await instance.put(
      ADMIN_LEVEL_URLS.UPDATE_ADMIN_LEVEL.replace(':id', id?.toString()),
      data
    );
    return response;
  };

export const deleteAdminLevel = (id: number) => async () => {
  const response = await instance.delete(
    ADMIN_LEVEL_URLS.DELETE_ADMIN_LEVEL.replace(':id', id?.toString())
  );
  return response;
};
